import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

function TermsOfService() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <Link to="/" className="logo-link">
          <img src="/logoBrivefood.png" alt="BriveFood" className="logo" />
        </Link>
        <h1 className="page-title">Conditions Générales d'Utilisation</h1>
      </header>

      <main className="legal-content">
        <p className="last-updated">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

        <section className="legal-section">
          <h2>1. Objet</h2>
          <p>
            Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation de l'application mobile
            BriveFood et de tous les services associés. En utilisant notre application, vous acceptez d'être lié
            par ces conditions.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Présentation du Service</h2>
          <p>
            BriveFood est un service de commande et de livraison de repas. Notre application permet aux utilisateurs
            de commander des plats auprès de notre restaurant et de se faire livrer à l'adresse de leur choix
            dans notre zone de livraison.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Inscription et Compte Utilisateur</h2>
          <ul>
            <li>L'inscription est gratuite et nécessaire pour passer une commande</li>
            <li>Vous devez fournir des informations exactes et complètes</li>
            <li>Vous êtes responsable de la confidentialité de vos identifiants de connexion</li>
            <li>Vous devez avoir au moins 16 ans pour créer un compte</li>
            <li>Un seul compte par personne est autorisé</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Commandes</h2>
          <h3>4.1 Passation de commande</h3>
          <p>
            Pour passer une commande, vous devez sélectionner les produits souhaités, confirmer votre adresse
            de livraison et procéder au paiement. La commande est confirmée une fois le paiement validé.
          </p>

          <h3>4.2 Prix</h3>
          <p>
            Les prix affichés sont en euros TTC. Ils incluent la TVA applicable au moment de la commande.
            Les frais de livraison sont indiqués séparément avant la validation de la commande.
          </p>

          <h3>4.3 Paiement</h3>
          <p>
            Le paiement s'effectue en ligne par carte bancaire via notre prestataire de paiement sécurisé.
            Le paiement en espèces à la livraison peut être disponible selon les conditions en vigueur.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Livraison</h2>
          <ul>
            <li>Les livraisons sont effectuées dans notre zone de livraison définie</li>
            <li>Les délais de livraison sont indicatifs et peuvent varier selon l'affluence</li>
            <li>Vous devez être présent à l'adresse indiquée au moment de la livraison</li>
            <li>En cas d'absence, nous tenterons de vous contacter. Sans réponse, la commande pourra être annulée</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Annulation et Remboursement</h2>
          <h3>6.1 Annulation par le client</h3>
          <p>
            Vous pouvez annuler votre commande gratuitement si elle n'a pas encore été préparée.
            Une fois la préparation commencée, l'annulation n'est plus possible.
          </p>

          <h3>6.2 Annulation par BriveFood</h3>
          <p>
            Nous nous réservons le droit d'annuler une commande en cas d'indisponibilité de produits,
            d'erreur de prix manifeste, ou de suspicion de fraude. Dans ce cas, vous serez intégralement remboursé.
          </p>

          <h3>6.3 Réclamations</h3>
          <p>
            Toute réclamation doit être effectuée dans les 24 heures suivant la livraison.
            Contactez notre service client avec les détails de votre commande et les motifs de réclamation.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Allergènes et Informations Nutritionnelles</h2>
          <p>
            Les informations sur les allergènes sont disponibles pour chaque produit. Il est de votre responsabilité
            de vérifier ces informations avant de commander. En cas d'allergie alimentaire sévère, nous vous
            recommandons de nous contacter avant de passer commande.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Propriété Intellectuelle</h2>
          <p>
            L'ensemble des contenus de l'application (logos, textes, images, graphismes, etc.) sont la propriété
            exclusive de BriveFood et sont protégés par les lois sur la propriété intellectuelle. Toute reproduction
            ou utilisation non autorisée est strictement interdite.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Responsabilités</h2>
          <h3>9.1 Responsabilité de BriveFood</h3>
          <p>
            Nous nous engageons à fournir un service de qualité. Toutefois, nous ne pouvons être tenus responsables
            des dommages indirects résultant de l'utilisation de notre service.
          </p>

          <h3>9.2 Responsabilité de l'utilisateur</h3>
          <p>
            Vous vous engagez à utiliser notre application de manière conforme aux lois en vigueur et à ne pas
            perturber le fonctionnement du service.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Programme de Fidélité</h2>
          <p>
            BriveFood peut proposer un programme de fidélité dont les conditions spécifiques sont détaillées
            dans l'application. Les points et avantages acquis sont personnels et non transférables.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Modification des CGU</h2>
          <p>
            Nous nous réservons le droit de modifier ces CGU à tout moment. Les modifications prendront effet
            dès leur publication. L'utilisation continue de l'application après modification vaut acceptation
            des nouvelles conditions.
          </p>
        </section>

        <section className="legal-section">
          <h2>12. Droit Applicable et Litiges</h2>
          <p>
            Les présentes CGU sont régies par le droit français. En cas de litige, une solution amiable sera
            recherchée avant toute action judiciaire. À défaut d'accord, les tribunaux français seront compétents.
          </p>
          <p>
            Conformément à l'article L.612-1 du Code de la consommation, vous pouvez recourir gratuitement
            au service de médiation de la consommation.
          </p>
        </section>

        <section className="legal-section">
          <h2>13. Contact</h2>
          <p>Pour toute question concernant ces conditions, contactez-nous :</p>
          <div className="contact-info">
            <p><strong>BriveFood</strong></p>
            <p>Email : brivefood@gmail.com</p>
          </div>
        </section>
      </main>

      <footer className="legal-footer">
        <div className="footer-links">
          <Link to="/">Télécharger l'App</Link>
          <Link to="/politique-de-confidentialite">Politique de Confidentialité</Link>
          <Link to="/conditions-generales">Conditions Générales d'Utilisation</Link>
        </div>
        <p className="copyright">&copy; {new Date().getFullYear()} BriveFood. Tous droits réservés.</p>
      </footer>
    </div>
  );
}

export default TermsOfService;
